/**
 * Русские склонения по числу. Формы задаются тройкой: 1 текст / 2 текста / 5 текстов.
 */
export type PluralForms = readonly [one: string, few: string, many: string]

export function pluralizeRu(n: number, forms: PluralForms): string {
	const mod100 = Math.abs(n) % 100
	const mod10 = mod100 % 10
	// 11–19 всегда «многие» (11 текстов, 114 текстов), поэтому проверяется до mod10
	if (mod100 > 10 && mod100 < 20) return forms[2]
	if (mod10 === 1) return forms[0]
	if (mod10 >= 2 && mod10 <= 4) return forms[1]
	return forms[2]
}

export const PLURAL_FORMS = {
	text: ['текст', 'текста', 'текстов'],
	image: ['картинка', 'картинки', 'картинок'],
	song: ['песня', 'песни', 'песен'],
	day: ['день', 'дня', 'дней']
} as const satisfies Record<string, PluralForms>
